import Button from "./Button.jsx";

export default function Panel(props) {
  return (
    <div className={`panel ${props.color}`}>
      <h1>{props.header}</h1>
      <p>{props.children}</p>
      <Button>Learn More</Button>
    </div>
  );
}
